import CustomCheckbox from 'components/CastomCheckbox';
import React, { memo, useCallback } from 'react';
import { Notification, NotificationTypeText } from '@app/models';
import { dateFormat } from '@app/helpers';
import { readNotifications } from '@app/api';

interface NotificationItemContentProps {
  notification: Notification;
  getData?: () => void;
  onClick?: () => void;
}

const NotificationItemContent = memo((props: NotificationItemContentProps) => {
  const { notification, getData, onClick } = props;

  const onReadNotification = useCallback(async () => {
    await readNotifications(notification.id);
    if (!!getData) await getData();
  }, [getData, notification.id]);

  const onClickNotification = useCallback(
    (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (!onClick) {
        return;
      }

      onClick();
    },
    [onClick]
  );

  return (
    <li className="flex justify-between items-center bg-gray-50 rounded-lg p-4 shadow-sm">
      <div className="flex-1 min-w-0">
        <span className="block font-semibold text-base text-gray-900 truncate">
          {NotificationTypeText[notification.type]}
        </span>
        <p className="text-sm text-gray-700 truncate mb-1">
          {notification.message}
        </p>
        <span
          className={
            'text-blue-600 text-xs font-medium cursor-pointer hover:underline ' +
            (!notification.data ? 'opacity-50 pointer-events-none' : '')
          }
          onClick={onClickNotification}
        >
          Открыть
        </span>
      </div>
      <div className="flex flex-col items-end min-w-[90px] ml-4 gap-2">
        <div className="flex flex-col items-end">
          <p className="text-xs text-gray-500 mb-0 leading-tight">
            {dateFormat(notification.createdAt)}
          </p>
          <span className="text-xs text-gray-400">
            {dateFormat(notification.createdAt, 'hh:mm')}
          </span>
        </div>
        <CustomCheckbox
          onClick={onReadNotification}
          toggleCheckbox={notification.isRead}
        />
      </div>
    </li>
  );
});

export default NotificationItemContent;
